import React from 'react'

const AccountStatement = () => {
  return (
    <div>AccountStatement</div>
  )
}

export default AccountStatement